export const TEXTS = {
  ACTION_LABEL: 'Request documents link',
  GENERATE_DIALOG_TITLE: 'Request documents link',
  // A submitted link is spent: the app refuses it at init (410 already_used, DR §5.7).
  GENERATE_DIALOG_INTRO:
    'Generate a single-use link the claimant can open to upload documents to this claim. You can then send it to the contact below by SMS or email, or copy it.',
  GENERATE_BUTTON: 'Generate link',
  CANCEL_BUTTON: 'Cancel',
  CONTINUE_BUTTON: 'Continue',
  CLOSE_BUTTON: 'Close',
  CONTACT_LABEL: 'Send To',
  CONTACT_REQUIRED: 'Required',
  SHARE_DIALOG_TITLE: 'Document request link',
  SHARE_DIALOG_INTRO: 'The link was created. You can copy it, or send it to the contact by SMS or email.',
  SHARE_LINK_TITLE: 'Upload link',
  SHARE_TEMPLATE_FAILED: 'The message could not be prepared. Copy the link instead.',
  GENERATED_LINK_EXPIRES: (expiresAt: string): string => `Expires ${expiresAt}`,
  GENERATED_LINK_MISSING: 'The link was created but cannot be displayed. Close this dialog and generate a new one.',
  LINKS_TITLE: 'Links',
  FILES_TITLE: 'Received files',
  FILES_HINT: 'Not part of the claim until attached.',
  FILES_EMPTY: 'No files have been received yet.',
  FILES_ALL_ATTACHED: 'All received files are attached to the claim.',
  SHOW_ATTACHED_LABEL: (count: number): string => `Show attached (${count})`,
  LINKS_EMPTY: 'No document request links have been generated for this claim yet.',
  NEW_LINK_BUTTON: 'Request Documents Link',
  LINK_ACTIONS_ARIA_LABEL: 'Link actions',
  COPY_LINK_MENU_ITEM: 'Copy Link',
  RESEND_SMS_MENU_ITEM: 'Resend SMS',
  RESEND_EMAIL_MENU_ITEM: 'Resend Email',
  RESEND_RECIPIENT_INTRO: 'Choose the contact to send this link to.',
  RESEND_PREPARING: 'Preparing the message…',
  RESEND_SMS_BLOCKED: 'You cannot send an SMS to this contact.',
  RESEND_EMAIL_BLOCKED: 'You cannot send an email to this contact.',
  COPY_LINK_SUCCESS: 'Copied to clipboard',
  COPY_LINK_FAILED: 'Failed to copy to clipboard',
  CANCEL_LINK_MENU_ITEM: 'Cancel Request',
  COLUMN_ACTIONS: 'Actions',
  CANCEL_CONFIRM_TITLE: 'Cancel this document request?',
  CANCEL_CONFIRM_TEXT:
    'The claimant will no longer be able to upload files with this link. This cannot be undone; to ask again, generate a new link.',
  CANCEL_CONFIRM_BUTTON: 'Cancel request',
  CANCEL_KEEP_BUTTON: 'Keep',
  COLUMN_LINK_ID: 'Link ID',
  COLUMN_FROM_LINK: 'From link',
  linkIdDisplay: (id: number): string => `#${id}`,
  COLUMN_STATUS: 'Status',
  COLUMN_EXPIRES: 'Expires',
  COLUMN_SUBMITTED: 'Submitted',
  COLUMN_FILES: 'Files',
  COLUMN_FILE_NAME: 'File',
  COLUMN_SCAN: 'Scan',
  COLUMN_ATTACHED: 'Attached',
  ATTACHED_YES: 'Attached',
  ATTACHED_NO: '-',
  LINK_STATUS_PENDING: 'Awaiting upload',
  LINK_STATUS_UPLOADING: 'Uploading',
  LINK_STATUS_EXPIRED: 'Expired',
  LINK_STATUS_SUBMITTED: 'Submitted',
  LINK_STATUS_CANCELLED: 'Cancelled',
  SCAN_PENDING: 'Scanning',
  SCAN_CLEAN: 'Clean',
  SCAN_SUSPICIOUS: 'Suspicious',
  SCAN_ERROR: 'Scan failed',
  PREVIEW_BUTTON: 'Preview',
  ATTACH_BUTTON: 'Attach',
  RESCAN_BUTTON: 'Rescan',
  PREVIEW_ARIA_LABEL: (fileName: string): string => `Preview ${fileName}`,
  ATTACH_ARIA_LABEL: (fileName: string): string => `Attach ${fileName}`,
  RESCAN_ARIA_LABEL: (fileName: string): string => `Rescan ${fileName}`,
  ATTACH_DIALOG_TITLE: 'Attach to claim',
  ATTACH_DIALOG_FILE: (fileName: string): string => `File: ${fileName}`,
  ATTACH_SUBMIT: 'Attach',
} as const;
